module.exports = __webpack_public_path__ + "static/media/kate.ff88e7f1.png";